import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { sendPlaybackCommand } from "./playbackActionCreators";
import { Dropdown, Header, Icon } from "semantic-ui-react";
import { accessStates, playbackCommands } from "./playbackCommands";

class VotifyPlaybackControl extends Component {
  render() {
    if (this.props.isHost) {
      return (
        <Dropdown icon={this.props.icon}>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => this.props.pause()}>
              <Icon name={"pause"} />
            </Dropdown.Item>
            <Dropdown.Item onClick={() => this.props.play()} icon={"play"} />
            <Dropdown.Item
              onClick={() => this.props.skip()}
              icon={"step forward"}
            />
            {this.props.accessState === accessStates.STOP ? (
              <Dropdown.Item onClick={() => this.props.start()}>
                <Header
                  as={"h5"}
                  color={"green"}
                  content={"Reconnect Spotbox to your playlist"}
                />
              </Dropdown.Item>
            ) : (
              <Dropdown.Item onClick={() => this.props.stop()}>
                <Header
                  as={"h5"}
                  color={"red"}
                  content={"Disconnect Spotbox from your playlist"}
                />
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        </Dropdown>
      );
    } else {
      return <Icon />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    accessState: state.playback.accessState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    start: () => dispatch(sendPlaybackCommand(playbackCommands.START)),
    stop: () => dispatch(sendPlaybackCommand(playbackCommands.STOP)),
    play: () => dispatch(sendPlaybackCommand(playbackCommands.PLAY)),
    pause: () => dispatch(sendPlaybackCommand(playbackCommands.PAUSE)),
    skip: () => dispatch(sendPlaybackCommand(playbackCommands.SKIP)),
  };
};

VotifyPlaybackControl.propTypes = {
  pause: PropTypes.func.isRequired,
  start: PropTypes.func.isRequired,
  play: PropTypes.func.isRequired,
  skip: PropTypes.func.isRequired,
  stop: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  accessState: PropTypes.string.isRequired,
  playingState: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VotifyPlaybackControl);
